import {Component, OnInit, Input, OnDestroy, ViewChild, ElementRef, AfterViewInit} from '@angular/core';

import {ModalService} from '@myServices/modal.service';
import {AuthenticationService} from '@myServices/authentication.service';
import {Subject} from 'rxjs/Subject';

@Component({
    selector: 'app-game',
    templateUrl: './game.component.html',
    styleUrls: ['./game.component.css']
})
export class GameComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('iframeTemplate') iframeTemplate: ElementRef;

    public showGame = false;
    public fullScreen: Boolean = false;
    public withFullWidth: Boolean = false;
    public isLargerModal: boolean;
    public postMessageClientHeight = null;
    private destroy$: Subject<void> = new Subject<void>();
    el: HTMLFrameElement;
    messageEventListener: any;
    @Input() public iframeUrl: String;
    @Input() public game: any;
    @Input() public isEmbedded = false;
    @Input() public showCloseGameIcon = true;

    constructor(private modalService: ModalService,
                private authenticationService: AuthenticationService,
    ) {
    }

    ngOnInit() {
        if (this.game) {
            this.authenticationService.currentGame = this.game['id'];
        }

        if (location.href.includes('virtual-sports') || location.href.includes('header-game')) {
            this.withFullWidth = true;
        }

        if (localStorage.getItem('isLargerModal')) {
            this.isLargerModal = JSON.parse(localStorage.getItem('isLargerModal'));
        }

    }

    ngAfterViewInit() {
        this.messageEventListener =  (event: MessageEvent) => {
            if (event.data.action === 'game.resize.height') {
                this.postMessageClientHeight = event.data.value;
                this.iframeTemplate.nativeElement.style.height = event.data.value;
            }
        };
        window.addEventListener('message', this.messageEventListener);
    }

    closeGame() {
        this.modalService.destroy();
        document.body.classList.remove('game-modal-header');
        this.authenticationService.currentGame = 0;
    }

    // showGameInfo(){
    //   this.showGame = !this.showGame;
    // }
    setFullScreen() {
        this.fullScreen = !this.fullScreen;
        this.modalService.fullScreenDefault = !this.modalService.fullScreenDefault;
        this.modalService.fullScreen();
    }

    onload(e: Event) {
        this.el = <HTMLFrameElement>e.srcElement;
        // Adjust iFrame height
        const iframeHeight = this.postMessageClientHeight || window.screen.availHeight;
        this.el.style.height = iframeHeight.toString() + 'px';
    }

    ngOnDestroy() {
        this.destroy$.next();
        window.removeEventListener('message', this.messageEventListener);
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/game/game.component.ts